function lsTest() {
  const test = 'test'
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  }
  catch (e) {
    return false
  }
}

export const isLocalStorageAvailable = lsTest()
